import { HOUR_WIDTH, ROW_HEIGHT, type HourRange } from '@/utils/timeline';

interface TimelineGridProps {
  range: HourRange;
  rowCount: number;
}

/**
 * Background layer for the timeline body: alternating row stripes, hour and
 * half-hour vertical gridlines. Purely presentational; bars render above it.
 */
export default function TimelineGrid({ range, rowCount }: TimelineGridProps) {
  const hours = range.endHour - range.startHour;
  const height = rowCount * ROW_HEIGHT;

  return (
    <div className="absolute inset-0 pointer-events-none">
      {/* Row stripes + separators */}
      {Array.from({ length: rowCount }, (_, i) => (
        <div
          key={`row-${i}`}
          className={`absolute left-0 right-0 border-b border-gray-200 ${
            i % 2 === 1 ? 'bg-gray-50' : 'bg-white'
          }`}
          style={{ top: i * ROW_HEIGHT, height: ROW_HEIGHT }}
        />
      ))}

      {/* Vertical hour + half-hour lines */}
      {Array.from({ length: hours }, (_, i) => (
        <div key={`h-${i}`}>
          <div
            className="absolute top-0 border-l border-gray-300"
            style={{ left: i * HOUR_WIDTH, height }}
          />
          <div
            className="absolute top-0 border-l border-gray-100"
            style={{ left: i * HOUR_WIDTH + HOUR_WIDTH / 2, height }}
          />
        </div>
      ))}
      {/* trailing edge */}
      <div className="absolute top-0 border-l border-gray-300" style={{ left: hours * HOUR_WIDTH, height }} />
    </div>
  );
}
